import {styled} from "@mui/material/styles"
import {breakpoints} from "@next/ux-fabric"

export const StyledContentBannerContainer = styled("div")`
    height: 2.25rem;
    display: inline-flex;
    align-items: center;
    width: 100%;
    background: ${({theme}) => theme.uxfabric.components.appBar.globalBar.default.backgroundColor};
    @media (max-width: ${breakpoints.values.md - 1}px) {
        padding: 0 1rem 0 1rem;
    }
`
